const doc = [({"zh_cn":({"adminButtonHotelCalendar":({"deleteSpecifiedStaysOnlyPeriod":"取消夜间限制期"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;